// services/ImportExportService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// Liste des entités importables/exportables accessibles au compte connecté
export function getImportableEntities() {
    return api.get(ENDPOINTS.IMPORT_EXPORT.ENTITIES);
}

// Télécharge le modèle Excel vierge d'une entité (déclenche le téléchargement navigateur)
export async function downloadTemplate(entityKey, entityLabel) {
    const res = await api.get(ENDPOINTS.IMPORT_EXPORT.TEMPLATE(entityKey), {
        responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `modele_${entityLabel || entityKey}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

// Exporte les données EXISTANTES d'une entité (pas un modèle vierge), même format de colonnes
export async function exportEntityData(entityKey, entityLabel) {
    const res = await api.get(ENDPOINTS.IMPORT_EXPORT.EXPORT(entityKey), {
        responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `export_${entityLabel || entityKey}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

// Importe un fichier rempli pour une entité donnée. mode: "skip" | "update"
export function importEntityFile(entityKey, file, mode = "skip") {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("mode", mode);
    return api.post(ENDPOINTS.IMPORT_EXPORT.IMPORT(entityKey), formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}
